import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/account-menu")({
  component: lazyRouteComponent(() => import("./-pages/admin.account-menu")),
  head: () => ({
    meta: [
      { title: "ترتيب قائمة الحساب — إدارة" },
      {
        name: "description",
        content: "رتّب وأخفِ أقسام وصفوف صفحة /account للموبايل والديسكتوب.",
      },
    ],
  }),
});
